import {
  GET_INCIDENTS,
  GET_INCIDENTS_SUCCESS,
  GET_INCIDENTS_FAIL,
  CREATE_INCIDENT,
  CREATE_INCIDENT_SUCCESS,
  CREATE_INCIDENT_FAIL,
  GET_INCIDENT_BY_ID,
  GET_INCIDENT_BY_ID_SUCCESS,
  GET_INCIDENT_BY_ID_FAIL,
  UPDATE_INCIDENT,
  UPDATE_INCIDENT_SUCCESS,
  UPDATE_INCIDENT_FAIL,
  CREATE_COMPONENT_SERVICE,
  CREATE_COMPONENT_SERVICE_SUCCESS,
  CREATE_COMPONENT_SERVICE_FAIL,
  GET_COMPONENT_SERVICES,
  GET_COMPONENT_SERVICES_SUCCESS,
  GET_COMPONENT_SERVICES_FAIL,
  GET_STATUS_PAGE_PUBLIC,
  GET_STATUS_PAGE_PUBLIC_SUCCESS,
  GET_STATUS_PAGE_PUBLIC_FAIL,
  GET_TIMESTAMP_DATA,
  GET_TIMESTAMP_DATA_SUCCESS,
  GET_TIMESTAMP_DATA_FAIL,
  GET_UPTIME_DETAILS,
  GET_UPTIME_DETAILS_SUCCESS,
  GET_UPTIME_DETAILS_FAIL,
  DELETE_COMPONENT_SERVICE,
  DELETE_COMPONENT_SERVICE_SUCCESS,
  DELETE_COMPONENT_SERVICE_FAIL,
  DELETE_INCIDENT,
  DELETE_INCIDENT_SUCCESS,
  DELETE_INCIDENT_FAIL,
  GET_TIMESTAMP_DATA_FOR_ONE_DAY,
  GET_TIMESTAMP_DATA_FOR_ONE_DAY_FAIL,
  GET_TIMESTAMP_DATA_FOR_ONE_DAY_SUCCESS,
  GET_COMPONENT_SERVICES_PUBLIC_PAGE_SUCCESS,
  GET_COMPONENT_SERVICES_PUBLIC_PAGE,
  GET_COMPONENT_SERVICES_PUBLIC_PAGE_FAIL,
  GET_INCIDENTS_PUBLIC_PAGE,
  GET_INCIDENTS_PUBLIC_PAGE_SUCCESS,
  GET_INCIDENTS_PUBLIC_PAGE_FAIL,
  GET_TIMESTAMP_DATA_PUBLIC_PAGE,
  GET_TIMESTAMP_DATA_PUBLIC_PAGE_SUCCESS,
  GET_TIMESTAMP_DATA_PUBLIC_PAGE_FAIL,
  GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY,
  GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY_SUCCESS,
  GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY_FAIL,
  VERIFY_RECAPTCHA,
  VERIFY_RECAPTCHA_FAIL,
  VERIFY_RECAPTCHA_SUCCESS,
  SUBSCRIBE_TO_STATUS_PAGE,
  SUBSCRIBE_TO_STATUS_PAGE_SUCCESS,
  SUBSCRIBE_TO_STATUS_PAGE_FAIL,
  STATUS_PAGE_EMAIL_CONFIRMATION,
  STATUS_PAGE_EMAIL_CONFIRMATION_SUCCESS,
  STATUS_PAGE_EMAIL_CONFIRMATION_FAIL,
  GET_EXTERNAL_COMPONENT_SERVICES,
  GET_EXTERNAL_COMPONENT_SERVICES_SUCCESS,
  GET_EXTERNAL_COMPONENT_SERVICES_FAIL,
  GET_AWS_HEALTH_EVENTS,
  GET_AWS_HEALTH_EVENT_SUCCESS,
  GET_AWS_HEALTH_EVENT_FAIL,
  MAP_ALERTS_TO_COMPONENT_SERVICE,
  MAP_ALERTS_TO_COMPONENT_SERVICE_SUCCESS,
  MAP_ALERTS_TO_COMPONENT_SERVICE_FAIL,
  GET_MAPPED_ALERTS,
  GET_MAPPED_ALERTS_SUCCESS,
  GET_MAPPED_ALERTS_FAIL, GET_ALL_RESOURCES, GET_ALL_RESOURCES_FAIL, GET_ALL_RESOURCES_SUCCESS, GET_RESOURCES_COUNT,
  GET_RESOURCES_COUNT_SUCCESS, GET_RESOURCES_COUNT_FAIL, DISASSOCIATE_ALERTS_TO_COMPONENT_SERVICE, DISASSOCIATE_ALERTS_TO_COMPONENT_SERVICE_SUCCESS,
  DISASSOCIATE_ALERTS_TO_COMPONENT_SERVICE_FAIL
} from "./actionTypes";

export const getIncidents = () => ({
    type: GET_INCIDENTS,
});

export const getIncidentsSuccess = incidents => ({
    type: GET_INCIDENTS_SUCCESS,
    payload: incidents,
});

export const getIncidentsFail = error => ({
    type: GET_INCIDENTS_FAIL,
    payload: error,
});

export const createIncident = (incident) => ({
    type: CREATE_INCIDENT,
    payload: incident
  });

  export const createIncidentSuccess = incident => ({
    type: CREATE_INCIDENT_SUCCESS,
    payload: incident
  });

  export const createIncidentFail = error => ({
    type: CREATE_INCIDENT_FAIL,
    payload: error
  });

  export const createComponentService = (component_service) => ({
    type: CREATE_COMPONENT_SERVICE,
    payload: component_service
  });

  export const createComponentServiceSuccess = component_service => ({
    type: CREATE_COMPONENT_SERVICE_SUCCESS,
    payload: component_service
  });

  export const createComponentServiceFail = error => ({
    type: CREATE_COMPONENT_SERVICE_FAIL,
    payload: error
  });

  export const getComponents = () => {
    return {
      type: GET_COMPONENT_SERVICES
    }
  }

  export const getComponentsSuccess = components => ({
    type: GET_COMPONENT_SERVICES_SUCCESS,
    payload: components,
  })

  export const getComponentsFail = error => ({
    type: GET_COMPONENT_SERVICES_FAIL,
    payload: error,
  })


  export const getIncidentById = (incident_id) => {
    return {
      type: GET_INCIDENT_BY_ID,
      payload: { incident_id }
    }
  }

  export const getIncidentByIdSuccess = incident => ({
    type: GET_INCIDENT_BY_ID_SUCCESS,
    payload: incident,
  })

  export const getIncidentByIdFail = error => ({
    type: GET_INCIDENT_BY_ID_FAIL,
    payload: error,
  })

  export const updateIncident = (incident) => {
    return {
      type: UPDATE_INCIDENT,
      payload: { incident }
    }
  }

  export const updateIncidentSuccess = incident => ({
    type: UPDATE_INCIDENT_SUCCESS,
    payload: incident,
  })

  export const updateIncidentFail = error => ({
    type: UPDATE_INCIDENT_FAIL,
    payload: error,
  })

export const getStatusPageState = () => ({
  type: GET_STATUS_PAGE_PUBLIC,
});

export const getStatusPageStateSuccess = state => ({
  type: GET_STATUS_PAGE_PUBLIC_SUCCESS,
  payload: state,
});

export const getStatusPageStateFail = error => ({
  type: GET_STATUS_PAGE_PUBLIC_FAIL,
  payload: error,
});



export const getTimeStampData = (timeDuration) => ({
  type: GET_TIMESTAMP_DATA,
  payload: timeDuration
})

export const getTimeStampDataSuccess = data => ({
  type: GET_TIMESTAMP_DATA_SUCCESS,
  payload: data,
})

export const getTimeStampDataFail = error => ({
  type: GET_TIMESTAMP_DATA_FAIL,
  payload: error,
})

export const getTimeStampDataForOneDay = (timeDuration) => ({
  type: GET_TIMESTAMP_DATA_FOR_ONE_DAY,
  payload: timeDuration
})

export const getTimeStampDataForOneDaySuccess = data => ({
  type: GET_TIMESTAMP_DATA_FOR_ONE_DAY_SUCCESS,
  payload: data,
})

export const getTimeStampDataForOneDayFail = error => ({
  type: GET_TIMESTAMP_DATA_FOR_ONE_DAY_FAIL,
  payload: error,
})

export const getUptimeDetails = () => ({
  type: GET_UPTIME_DETAILS,
})

export const getUptimeDetailsSuccess = data => ({
  type: GET_UPTIME_DETAILS_SUCCESS,
  payload: data,
})

export const getUptimeDetailsFail = error => ({
  type: GET_UPTIME_DETAILS_FAIL,
  payload: error,
})

export const deleteComponentService = (component_service_id) => ({
  type: DELETE_COMPONENT_SERVICE,
  payload: component_service_id
})

export const deleteComponentServiceSuccess = component_service_id => ({
  type: DELETE_COMPONENT_SERVICE_SUCCESS,
  payload: component_service_id,
})

export const deleteComponentServiceFail = error => ({
  type: DELETE_COMPONENT_SERVICE_FAIL,
  payload: error,
})

export const deleteIncident = (incident_id) => ({
  type: DELETE_INCIDENT,
  payload: incident_id
})

export const deleteIncidentSuccess = incident_id => ({
  type: DELETE_INCIDENT_SUCCESS,
  payload: incident_id,
})

export const deleteIncidentFail = error => ({
  type: DELETE_INCIDENT_FAIL,
  payload: error,
})

export const getComponentsPublicPage = () => {
  return {
    type: GET_COMPONENT_SERVICES_PUBLIC_PAGE
  }
}

export const getComponentsPublicPageSuccess = components => ({
  type: GET_COMPONENT_SERVICES_PUBLIC_PAGE_SUCCESS,
  payload: components,
})

export const getComponentsPublicPageFail = error => ({
  type: GET_COMPONENT_SERVICES_PUBLIC_PAGE_FAIL,
  payload: error,
})


export const getIncidentsPublicPage = () => ({
  type: GET_INCIDENTS_PUBLIC_PAGE,
});

export const getIncidentsPublicPageSuccess = incidents => ({
  type: GET_INCIDENTS_PUBLIC_PAGE_SUCCESS,
  payload: incidents,
});

export const getIncidentsPublicPageFail = error => ({
  type: GET_INCIDENTS_PUBLIC_PAGE_FAIL,
  payload: error,
});


export const getTimeStampDataPublicPage = (timeDuration) => ({
  type: GET_TIMESTAMP_DATA_PUBLIC_PAGE,
  payload: timeDuration
})

export const getTimeStampDataPublicPageSuccess = data => ({
  type: GET_TIMESTAMP_DATA_PUBLIC_PAGE_SUCCESS,
  payload: data,
})

export const getTimeStampDataPublicPageFail = error => ({
  type: GET_TIMESTAMP_DATA_PUBLIC_PAGE_FAIL,
  payload: error,
})

export const getTimeStampDataForOneDayPublicPage = (timeDuration) => ({
  type: GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY,
  payload: timeDuration
})

export const getTimeStampDataForOneDayPublicPageSuccess = data => ({
  type: GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY_SUCCESS,
  payload: data,
})

export const getTimeStampDataForOneDayPublicPageFail = error => ({
  type: GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY_FAIL,
  payload: error,
})

export const verifyRecaptcha = (token) => ({
  type: VERIFY_RECAPTCHA,
  payload: { token }
});

export const verifyRecaptchaSuccess = (data) => ({
  type: VERIFY_RECAPTCHA_SUCCESS,
  payload: data,
});

export const verifyRecaptchaFail = (error) => ({
  type: VERIFY_RECAPTCHA_FAIL,
  payload: error
});

export const subscribeToStatusPage = (email) => ({
  type: SUBSCRIBE_TO_STATUS_PAGE,
  payload: email
});

export const subscribeToStatusPageSuccess = message => ({
  type: SUBSCRIBE_TO_STATUS_PAGE_SUCCESS,
  payload: message,
});

export const subscribeToStatusPageFail = error => ({
  type: SUBSCRIBE_TO_STATUS_PAGE_FAIL,
  payload: error,
});

export const statusPageEmailConfirmation = (token) => {
  return {
    type: STATUS_PAGE_EMAIL_CONFIRMATION,
    payload: { token },
  }
}

export const statusPageEmailConfirmationSuccess = success => ({
  type: STATUS_PAGE_EMAIL_CONFIRMATION_SUCCESS,
  payload: success,
})

export const statusPageEmailConfirmationFail = error => ({
  type: STATUS_PAGE_EMAIL_CONFIRMATION_FAIL,
  payload: error,
})

export const getExternalComponents = () => {
  return {
    type: GET_EXTERNAL_COMPONENT_SERVICES
  }
}

export const getExternalComponentsSuccess = components => ({
  type: GET_EXTERNAL_COMPONENT_SERVICES_SUCCESS,
  payload: components,
})

export const getExternalComponentsFail = error => ({
  type: GET_EXTERNAL_COMPONENT_SERVICES_FAIL,
  payload: error,
})

export const getAWSHealthEvents = () => {
  return {
    type: GET_AWS_HEALTH_EVENTS,
  }
}

export const getAWsHealthEventsSuccess = healthEvents => {
  return {
    type: GET_AWS_HEALTH_EVENT_SUCCESS,
    payload: healthEvents
  }
}

export const getAWsHealthEventsFail = error => ({
  type: GET_AWS_HEALTH_EVENT_FAIL,
  payload: error,
})

export const mapAlertsToComponentService = alerts_service_mapping => {
  return {
    type: MAP_ALERTS_TO_COMPONENT_SERVICE,
    payload:  alerts_service_mapping
  }
}

export const mapAlertsToComponentServiceSuccess = allAlerts => {
  return {
    type: MAP_ALERTS_TO_COMPONENT_SERVICE_SUCCESS,
    payload: allAlerts
  }
}

export const  mapAlertsToComponentsFail = error => ({
    type:MAP_ALERTS_TO_COMPONENT_SERVICE_FAIL,
    payload: error,
})

export const disassociateAlertToComponentService = alerts_service_mapping => {
  return {
    type: DISASSOCIATE_ALERTS_TO_COMPONENT_SERVICE,
    payload:  alerts_service_mapping
  }
}

export const disassociateAlertToComponentServiceSuccess = allAlerts => {
  return {
    type: DISASSOCIATE_ALERTS_TO_COMPONENT_SERVICE_SUCCESS,
    payload: allAlerts
  }
}

export const disassociateAlertToComponentsFail = error => ({
  type: DISASSOCIATE_ALERTS_TO_COMPONENT_SERVICE_FAIL,
  payload: error,
})

export const getMappedAlerts = () => {
  return {
    type: GET_MAPPED_ALERTS
  }
}

export const getMappedAlertsSuccess = data => ({
  type: GET_MAPPED_ALERTS_SUCCESS,
  payload: data,
})

export const getMappedAlertsFail = error => ({
  type: GET_MAPPED_ALERTS_FAIL,
  payload: error,
})

export const getAllResources = (page_filters) => ({
  type: GET_ALL_RESOURCES,
  payload: {page_filters}
})

export const getAllResourcesSuccess = all_resources => ({
  type: GET_ALL_RESOURCES_SUCCESS,
  payload: all_resources,
})

export const getAllResourcesFail = error => ({
  type: GET_ALL_RESOURCES_FAIL,
  payload: error,
})

export const getResourcesCount = (page_filters) => ({
  type: GET_RESOURCES_COUNT,
  payload: {page_filters}
})

export const getResourcesCountSuccess = resources_count => ({
  type: GET_RESOURCES_COUNT_SUCCESS,
  payload: resources_count,
})

export const getResourcesCountFail = error => ({
  type: GET_RESOURCES_COUNT_FAIL,
  payload: error,
})
